import { useEffect, useRef } from 'react';
import axios from 'axios';
import $ from 'jquery';

export default function cancelRequests() {
  const cancelTokensRef = useRef([]);       // Axios
  const fetchControllersRef = useRef([]);   // Fetch
  const ajaxRequestsRef = useRef([]);       // jQuery

  // Clean up on unmount
  useEffect(() => {

    return () => {
      // Axios cleanup
      cancelTokensRef.current.forEach(source => source.cancel('Component unmounted'));
      cancelTokensRef.current = [];

      // Fetch cleanup
      fetchControllersRef.current.forEach(ctrl => ctrl?.abort?.());
      fetchControllersRef.current = [];

      // jQuery AJAX cleanup
      ajaxRequestsRef.current.forEach(xhr => xhr?.abort?.());
      ajaxRequestsRef.current = [];
    };
  }, []);

  // Axios option generator
  function createCancelableAxiosOptions(originalOptions = {}) {
    const source = axios.CancelToken.source();
    cancelTokensRef.current.push(source);
    return {
      ...originalOptions,
      cancelToken: source.token
    };
  }

  // Fetch options generator
  function createCancelableFetchOptions(originalOptions = {}) {
    const controller = new AbortController();
    fetchControllersRef.current.push(controller);
    return {
      ...originalOptions,
      signal: controller.signal
    };
  }

  // jQuery AJAX wrapper
  function runCancelableAjax(ajaxOptions = {}) {
    const xhr = $.ajax(ajaxOptions);
    ajaxRequestsRef.current.push(xhr);
    return xhr;
  }

  return {
    createCancelableAxiosOptions,
    createCancelableFetchOptions,
    runCancelableAjax
  };
}
